import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const SuccessContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const SuccessIcon = styled(Box)(() => ({
  width: "120px",
  height: "120px",
  marginBottom: "44px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const SuccessTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const SuccessSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "44px",
}));

export const SuccessActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
